import { Component } from '@angular/core';
import { IonicPage } from 'ionic-angular';


@IonicPage()
@Component({
  selector: 'page-payroll',
  templateUrl: 'payroll.html',
})
export class PayrollPage {

  constructor() { }

  goPayroll() {
    window.open('http://summar.sebastia.info/empleado', '_system', 'location=yes'); return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/payroll/payroll.ts